var React = require('react');

function TvIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"m18.586 10-5.293-5.293a1 1 0 0 1 1.414-1.414L20 8.586l5.293-5.293a1 1 0 1 1 1.414 1.414L21.414 10H34a2 2 0 0 1 2 2v20a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V12a2 2 0 0 1 2-2h12.586zM6 32V12h28v20H6zm22-2a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm-2-1a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm5 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2z","fill":"#fff"}));
}

TvIcon.defaultProps = {"width":"40","height":"40","viewBox":"0 0 40 40","fill":"none"};

module.exports = TvIcon;

TvIcon.default = TvIcon;
